module.exports = __webpack_public_path__ + "static/media/4.69dff5bb.png";